import { useTranslation } from 'react-i18next';
import type { TenantSummary } from '@bliks-io/contracts';
import { ReadOnlyField } from '@bliks-io/ui';

interface TenantSalesScopeCellProps {
  tenant: TenantSummary;
}

/**
 * What the sales app reads off this tenant (SAL-09), shown rather than set:
 * the HubSpot company of its account (LIC-06) that scopes a partner's leads — or that it is missing,
 * and where to set it. Which tenant runs the internal edition is the app's
 * environment, not a superadmin setting, so nothing here is to choose.
 */
export function TenantSalesScopeCell({ tenant }: TenantSalesScopeCellProps) {
  const { t } = useTranslation();
  const companyId = tenant.hubspotCompanyId;

  return (
    <ReadOnlyField
      variant="stacked"
      label={t('adminSettings.tenant.appConfigSalesPartnerCompanyId')}
      value={
        companyId ? (
          <>
            <span className="font-mono">{companyId}</span>
            <span className="block text-muted-foreground">
              {t('adminSettings.tenant.appConfigSalesPartnerCompanyIdHint')}
            </span>
          </>
        ) : (
          <span className="text-destructive">
            {t('adminSettings.tenant.appConfigSalesPartnerCompanyIdMissing')}
          </span>
        )
      }
    />
  );
}
